export const CamelAttributes: string[] = [
  "viewBox",
  "preserveAspectRatio",
  "gradientTransform",
  "gradientUnits",
  "spreadMethod",
  "markerStart",
  "markerMid",
  "markerEnd",
  "markerHeight",
  "markerWidth",
  "markerUnits",
  "refX",
  "refY",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "filterUnits",
  "primitiveUnits",
  "kernelUnitLength",
  "clipPathUnits",
  "maskContentUnits",
  "maskUnits"
] as const
